"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6297],{

/***/ 26297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgShopping = function SvgShopping(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.291 21.663H4.887a.387.387 0 0 1-.385-.427l1.29-12.375a.387.387 0 0 1 .384-.346h9.023c.198 0 .364.15.385.346l.475 4.565a.387.387 0 0 1-.385.427h-1.221l-.777 7.464a.386.386 0 0 1-.385.346Zm-7.975-.773h7.627l.777-7.464a.387.387 0 0 1 .384-.347h1.141l-.394-3.791H6.524L5.316 20.89Z",
    fill: "#765346"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.48 11.544a.387.387 0 0 1-.386-.387V8.343a2.409 2.409 0 0 0-2.406-2.406A2.409 2.409 0 0 0 8.28 8.343v2.814a.387.387 0 0 1-.773 0V8.343a3.183 3.183 0 0 1 3.18-3.18 3.183 3.183 0 0 1 3.18 3.18l-.001 2.814a.387.387 0 0 1-.387.387ZM20.613 21.663h-7.322a.387.387 0 0 1-.385-.427l.814-7.81a.387.387 0 0 1 .384-.347H19.8c.198 0 .364.15.385.347l.813 7.81a.387.387 0 0 1-.384.427Zm-6.893-.773h6.464l-.732-7.037h-4.999l-.733 7.037Z",
    fill: "#765346"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16.951 17.505a1.758 1.758 0 0 1-1.756-1.757v-.579a.387.387 0 0 1 .774 0v.58a.984.984 0 0 0 1.965 0v-.58a.387.387 0 0 1 .774 0v.58c0 .968-.788 1.756-1.756 1.756ZM20.613 21.663h-7.322a.387.387 0 0 1-.385-.427l.22-2.115a.387.387 0 0 1 .385-.347h6.882c.198 0 .364.15.385.347l.22 2.116a.387.387 0 0 1-.385.426Zm-6.893-.773h6.464l-.14-1.342H13.86l-.14 1.342Z",
    fill: "#765346"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M13.291 21.663H4.887a.387.387 0 0 1-.385-.427l.35-3.351a.387.387 0 0 1 .384-.347h8.404a.386.386 0 0 1 .385.427l-.349 3.351a.387.387 0 0 1-.385.347Zm-7.975-.773h7.627l.268-2.578H5.584l-.268 2.578Z",
    fill: "#765346"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgShopping);

/***/ })

}]);